import { render, staticRenderFns } from "./identifiers.vue?vue&type=template&id=933910b2&scoped=true"
import script from "./identifiers.vue?vue&type=script&lang=js"
export * from "./identifiers.vue?vue&type=script&lang=js"
import style0 from "./identifiers.vue?vue&type=style&index=0&id=933910b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933910b2",
  null
  
)

export default component.exports